import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "../../styles/dash/ModulesModal.css";
import PermissionsTableModal from "./PermissionsTableModal";

interface infoModule {
    action: string;
    actionID: number;
}

interface GroupedModulo {
    modulo: string;
    actions: infoModule[];
}

// 1. Actualizar la interfaz para incluir actionId
interface RolePermission {
  idRol: number;
  roleName: string;
  statusRole: number;
  tienePermiso: number;
  action: string | null;
  actionId: number; // Nuevo campo
}

interface Props {
  show: boolean;
  onClose: () => void;
  modulos: GroupedModulo[];
  permisos: number[];
  roles: RolePermission[]; // Usar la nueva interfaz
  idRol: number | null;
  
  // 2. Actualizar onBatchUpdate para usar actionId
  onBatchUpdate: (changes: { idRol: number; actionId: number | null; nuevoEstado: number }[]) => void;
}

const ModulesModal: React.FC<Props> = ({
  show,
  onClose,
  modulos,
  permisos,
  roles,
  idRol,
  
  onBatchUpdate
}) => {
  const [animateOut, setAnimateOut] = useState(false);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [selectedModuleName, setSelectedModuleName] = useState("");


  const handleClose = () => {
    setAnimateOut(true);
    setTimeout(() => {
      onClose();
      setAnimateOut(false);
    }, 300);
  };

  const handleEditClick = (moduloName: string) => {
    const selected = modulos.find((m) => m.modulo === moduloName);
    if (selected) {
      setSelectedModuleName(moduloName);

      setShowPermissionsModal(true);
    }

    console.log(modulos, "Selected module and actions");

  };

  const uniqueModulos = Array.from(new Set(modulos.map(m => m.modulo)));

  if (!show && !animateOut) return null;

  return (
    <>
      <Modal
        show={!animateOut}
        onHide={handleClose}
        centered
        backdrop="static"
        contentClassName={`chatbot-form-modal ${animateOut ? "modal-exit" : "modal-enter"}`}
      >
        <Modal.Header closeButton closeVariant="white" className="border-0" />
        <Modal.Body className="chatbot-form-content">
          <h5 className="form-title text-center mb-4">Permisos por Módulo</h5>

          <table className="modules-table">
            <thead>
              <tr>
                <th>Módulo</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              {uniqueModulos.map((moduloName, index) => (
                <tr key={index}>
                  <td>{moduloName}</td>
                  <td>
                    <button
                      className="action-button edit"
                      title="Ver Modulos"
                      onClick={() => handleEditClick(moduloName)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>

      <PermissionsTableModal
        show={showPermissionsModal}
        onClose={() => setShowPermissionsModal(false)}
        moduloName={selectedModuleName}
        roles={roles.filter((r) => r.idRol === idRol && r.action !== null)}
        idRol={idRol}
        permisos={permisos}
        modulos={modulos}
        onBatchUpdate={onBatchUpdate}
      />
    </>
  );
};

export default ModulesModal;